<div mat-dialog-title class="cust-modal-title" style="    margin-bottom: 12px;
    padding-top: 12px;">
    <h2 class="m-0">Meeting info</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content *ngIf="!loader">
    <div style="margin-top: 10px;">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Virtual meeting info</mat-label>
          <textarea [readonly]="parentdata.isOwner == 0" rows="5" matInput [(ngModel)]="meeting_details"></textarea>
        </mat-form-field>
      </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" *ngIf="parentdata.isOwner == 1">
    <button mat-button mat-dialog-close>Close</button>
    <button
    [disabled]="!isNoteChanged"
    (click)="onConfirm()"
      mat-flat-button
      color="accent"
    >
      Update
    </button>
  </mat-dialog-actions>